<template>
  <div :id="id" :class="classes" v-if="selectedValues.length" >
    <section class="fl-active-filters">
      <span class="title">{{ $t('active_filters') }}</span>
      <span v-for="(filter_item, i) in selectedValues" :key="i" >
        <selected :filter_item="filter_item" @click="filterReset({id: filter_item.filter_id, filter: filter_item})"/>
      </span>
      <button type="button" class="btn btn-sm btn-secondary btn-fl-filter-delete" @click="filterResetAll()">
        {{ $t('delete_active_filters') }}
      </button>
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import selected from "./selected";

export default {
  name: "findologic-topbar",
  props: ['id', 'classes', 'filters', 'useCategoryFilter'],
  data: () => ({
    isMobile: false,
  }),
  components: {
    selected
  },
  created() {
  },
  mounted() {
    this.onMobile(() => {
      this.isMobile = false
    })
  },
  watch: {},
  computed: {
    ...mapGetters({
      selectedValues: 'logicFilters/selectedValues',
    }),
  },
  methods: {
    ...mapActions({
      filterReset: 'filterSelector/reset',
      filterResetAll: 'filterSelector/resetAll',
    }),
    onMobile(fn) {
      if (util.handleResize() !== 'large') {
        fn();
        this.isMobile = true;
      }
    },
  }
}

const util = {
  defaultBreakpoints: {
    small: 744,
    medium: 1060,
    large: Infinity
  },
  handleResize() {
    const clientWidth = window.innerWidth
    if (clientWidth < util.defaultBreakpoints.small) {
      return 'small'
    } else if (clientWidth < util.defaultBreakpoints.medium) {
      return 'medium'
    } else if (clientWidth <= util.defaultBreakpoints.large) {
      return 'large'
    }
  }
}
</script>

<style scoped>
  .fl-active-filters {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .fl-active-filters .title {
    margin: auto 0;
  }
</style>
